require([
    "common/urlUtils"
],
    function (urlUtils) {

        function initClickHandlers() {
            $(".product-category-banner .banner-video-text").off("click").on("click", displayVideo);
        }

        function displayVideo(event) {

            event.preventDefault();

            $(".product-category-banner .banner-image,.banner-video-text,.video").toggleClass("d-none");

            var videoElement = $(".product-category-banner .video iframe");
            videoElement[0].src = urlUtils.putParamIntoUrl("autoplay", "1", videoElement.data("src"));

        }

        initClickHandlers();
    });

define("ProductCategoryBanner/main", function(){});

